import { _ as __rest } from './_tslib.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { generateClasses, platform } from '@ids/tools';
import { s as styleInject } from './style-inject.es.js';

var css_248z = "/*\n** Voxel Foundation Formats\n*/\n.ids-form-selection {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  cursor: pointer;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  gap: var(--ids_size_general_8x);\n  position: relative;\n}\n.ids-form-selection .ids-checkbox,\n.ids-form-selection .ids-radio-button,\n.ids-form-selection .ids-switch {\n  position: static;\n}\n.ids-form-selection .ids-checkbox__input,\n.ids-form-selection .ids-radio-button__input,\n.ids-form-selection .ids-switch__input {\n  left: -0.1875rem;\n  outline-offset: 0;\n  width: calc(100% + var(--ids_size_general_6x));\n}\n.ids-form-selection__label {\n  padding-right: var(--ids_size_general_3x);\n}\n.ids-form-selection__input {\n  line-height: 1;\n}\n.ids-form-selection--disabled {\n  color: var(--ids_color_action_disabled_variant);\n  cursor: not-allowed;\n}\n.ids-form-selection--invalid {\n  font-weight: bold;\n}\n.ids-form-selection--on-brand {\n  color: var(--ids_color_contrast_onBrand_primary);\n}\n.ids-form-selection--rtl {\n  direction: rtl;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n}";
styleInject(css_248z);

/**
 * @category Component
 *
 * @example
 * ```ts
 * import { IdsFormSelection } from '@ids/react';
 * ```
 */
const IdsFormSelection = _a => {
  var {
      disabled,
      invalid,
      rtl,
      className = '',
      input,
      contrast,
      children,
      inputId,
      labelId,
      labelProps
    } = _a,
    props = __rest(_a, ["disabled", "invalid", "rtl", "className", "input", "contrast", "children", "inputId", "labelId", "labelProps"]);
  const classes = generateClasses({
    'ids-form-selection': true,
    'ids-form-selection--invalid': invalid,
    'ids-form-selection--disabled': disabled,
    'ids-form-selection--on-brand': contrast === 'onBrand',
    'ids-form-selection--full-visible-focus': platform.os !== 'IOS',
    [className]: className
  });
  const inputTemplate = jsx("div", Object.assign({
    className: "ids-form-selection__input"
  }, {
    children: input
  }));
  const labelTemplate = jsx("label", Object.assign({
    id: labelId,
    className: "ids-form-selection__label",
    "aria-hidden": "true",
    htmlFor: inputId
  }, labelProps, {
    children: children
  }));
  return jsx("div", Object.assign({
    className: classes
  }, props, {
    children: rtl ? jsxs(Fragment, {
      children: [labelTemplate, inputTemplate]
    }) : jsxs(Fragment, {
      children: [inputTemplate, labelTemplate]
    })
  }));
};

export { IdsFormSelection as I };
//# sourceMappingURL=form-selection.js.map
